import { createAsyncThunk } from "@reduxjs/toolkit";
import { salesRepCampaignService } from "../../services";

const createMessage = createAsyncThunk(
    'salesRepCampaign/createMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await salesRepCampaignService.createMessage(
                payload.companyId,
                payload.campaignId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateMessage = createAsyncThunk(
    'salesRepCampaign/updateMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await salesRepCampaignService.updateMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteMessage = createAsyncThunk(
    'salesRepCampaign/deleteMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await salesRepCampaignService.deleteMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getMessage = createAsyncThunk(
    'salesRepCampaign/getMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await salesRepCampaignService.getMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCampaignEchos = createAsyncThunk(
    'salesRepCampaign/getCampaignEchos',
    async (payload, ThunkAPI) => {
        try{
            const response = await salesRepCampaignService.getCampaignEchos(
                payload.companyId,
                payload.campaignId, 
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);


export {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessage,
    getCampaignEchos,
}